import { buildUrl } from "helpers";
import { instance } from "libs/api";

import {
  ApiRoutesSupport,
  SupportConversationSubRoute,
} from "../../constants/enums";
import { InAppMessage } from "../../support.types";
import { SendMessageRequestBody } from "./sendMessage.types";

export const requestSendMessage = async ({
  conversationId,
  text,
  imageUrl,
  audioUrl,
}: SendMessageRequestBody): Promise<InAppMessage> => {
  return await instance.post(
    buildUrl(
      ApiRoutesSupport.Conversations,
      conversationId,
      SupportConversationSubRoute.Messages,
    ),
    { text, imageUrl, audioUrl },
  );
};
